import React from 'react';
import { SUGGEST_PRODUCT_SKUS } from '../../../../apollo/queries/priceChangeRequest';
import { GenericFilterHeader } from './GenericFilterHeader';

interface SkuHeaderProps {
    readonly currentValue: string[] | null;
    readonly onChange: (value: string[] | null) => void;
}

export function SkuHeader({ currentValue, onChange }: SkuHeaderProps) {
    return (
        <GenericFilterHeader
            label="SKU"
            suggestProps={{
                label: 'SKU',
                query: SUGGEST_PRODUCT_SKUS,
                optionExtractor: data => data?.suggestProductSkus ?? [],
            }}
            currentValue={currentValue}
            onChange={onChange}
        />
    );
}

SkuHeader.displayName = 'SkuHeader';
